module.exports = __webpack_public_path__ + "img/carousel-5.fa7ff4b8.jpg";